const warningTypes = {
  1: {// Unsure -> always trigger
    message: "Last Treatment Unknown: The type and age of the last treatment are potential indicators of an underperforming treatment in RxPave. For example, Chip and Cape Seals have expected lives of 7-10 years, HMA overlays 10 -20 years, and reconstructed pavements have structural lives of at least 40 years.",
    note: "Generic because the user does not know"
  },
  2: { // Chip seal -> trigger if age < 7 yrs
    message: "Expected Life of Last Treatment Underperforming: You indicated that the last treatment on the segment was a Chip Seal (or FDR with a Chip Seal) performed less than 7 years ago. As the expected life of a Chip Seal is 7-10 years, your pavement may be underperforming.",
    note: "Last treatment is Chip-Seal related, and underperforming (< 7 years)",
  },
  3: { // HMA/Overlay -> Trigger if age < 10
    message: "Expected Life of Last Treatment Underperforming: You indicated that the last treatment on the segment was an HMA overlay (or FDR with an HMA Overlay) performed less than 10 years ago. As the expected life of an HMA overlay is 10-20 years, your pavement may be underperforming.",
    note: "Last treatment is HMA related, and underperforming (<10 years)"
  },
  4: { // New/Full recon -> Trigger if age < 10
    message: "Expected Life of Last Treatment Underperforming: You indicated that the last treatment on the segment was a full reconstruction completed less than 10 years ago. As the expected life of a fully reconstructed surface is 10-20 years, your pavement may be underperforming.",
    note: "Last treatment was reconstruction, but it’s too early to be considering surface treatment (<10 years)"
  },
  5: { // New/Full recon -> Trigger if age < 40
    message: "Expected Life of Last Treatment Underperforming: You indicated that the last treatment on the segment was a full reconstruction completed less than 40 years ago. As the expected structural life of a fully reconstructed pavement is at least 40 years, your pavement may be underperforming.",
    note: "Last treatment was reconstruction, but it's too early to consider structural life (<40 years)"
  }
};



export function checkPcrMoreRecentThanLastTreatment(lastPCRYear, lastTreatmentYear){
  const pcrMayBeInvalidWarning = {
    message: "Year of last PCR reading is older than the most recently reported rehabilitation activity. Further investigation may be warranted as this suggests that your PCR rating is outdated or inconsistent with actual current pavement conditions.",
    note: 'note'
  };

  if ((lastPCRYear <= lastTreatmentYear)){
    return pcrMayBeInvalidWarning
  } else {
    return null
  }
}

export function checkPcrRecentEnough(lastPcrYear){
  const currYear = () => {
    const d = new Date();
    return d.getFullYear()
  };

  const warning = {
    message: "Last PCR reading is over 4 years ago and may no longer accurately represent current conditions.\t"
  };

  if (currYear() - lastPcrYear > 4 ){
    return warning
  } else {
    return null
  }

}